<template>
  <div class="ViewRiskAnalysis" v-loading="loadingPage">
    <HeaderPage>
      <el-button @click="approve" style="height: 44px; margin-left: 1rem" type="success" v-if="['risk_analysis_manually', 'pending', 'risk_analysis_awaiting'].includes(dados.person_status)" >Aprovar</el-button>
      <el-button @click="awaiting" style="height: 44px; margin-left: 1rem" type="info" v-if="dados.person_status === 'risk_analysis_manually'" >Aguardando Documentação</el-button>
      <el-button @click="reprove" style="height: 44px; margin-left: 1rem" type="danger" v-if="['risk_analysis_manually', 'pending', 'risk_analysis_awaiting'].includes(dados.person_status)" >Reprovar</el-button>
      <el-button @click="retry" style="height: 44px; margin-left: 1rem" type="warning" v-if="['risk_analysis_error', 'risk_analysis_reproved', 'new', 'risk_analysis_rejected'].includes(dados.person_status)" >Reenviar</el-button>
      <el-button @click="reject" style="height: 44px; margin-left: 1rem" type="danger" v-if="['risk_analysis_reproved'].includes(dados.person_status)">Recusar</el-button>
    </HeaderPage>
    <el-card shadow="never">
      <el-descriptions :title="'Detalhes da Análise de Risco: '+dados.id_status" :column="3" border direction="vertical">
        <template slot="extra">
          <TagStatus :status="dados.person_status" />
        </template>
      </el-descriptions>
      <el-descriptions :column="3" border direction="vertical">
        <el-descriptions-item label="Nome completo">{{dados.name}}</el-descriptions-item>
        <el-descriptions-item label="Data de nascimento">{{ moment(dados.birthday).format('DD/MM/YYYY') }}</el-descriptions-item>
        <el-descriptions-item label="Gênero">{{ (dados.gender === 'male') ? 'Masculino' : 'Feminino' }}</el-descriptions-item>
        <el-descriptions-item label="CPF">{{dados.cpf}}</el-descriptions-item>
        <el-descriptions-item label="RG">{{dados.rg}}</el-descriptions-item>
        <el-descriptions-item label="Tipo de pessoa">{{ (dados.type_person === 'individual') ? 'Individual' : 'Empresa'  }}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="!dados.person_contacts" title="Contato não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions v-else title="Contatos" :column="4" border direction="vertical">
        <el-descriptions-item label="Tipo de Contato">{{ (dados.person_contacts.type_contact === 'personal') ? 'Pessoal' : 'Empresa' }}</el-descriptions-item>
        <el-descriptions-item label="Operadora">{{ dados.person_contacts.name}}</el-descriptions-item>
        <el-descriptions-item label="Telefone">{{ dados.person_contacts.phone }}</el-descriptions-item>
        <el-descriptions-item label="Email">{{ dados.person_contacts.email }}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-descriptions  v-if="dados.department_store_id" title="Estabelecimento Comercial" :column="2" border direction="vertical">
        <el-descriptions-item label="Nome do estabelecimento">{{dados.name_store}}</el-descriptions-item>
        <el-descriptions-item v-if="dados.business_cnpj" label="CNPJ">{{ dados.business_cnpj }}</el-descriptions-item>
        <el-descriptions-item label="TPV Esperado">{{ dados.tpv_expected }}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="!dados.person_bank_account" title="Dados Bancários não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions title="Dados bancários" v-else :column="4" border direction="vertical">
        <el-descriptions-item label="Banco">{{ dados.person_bank_account.name }}</el-descriptions-item>
        <el-descriptions-item label="Agência">{{ dados.person_bank_account.routing_number }}</el-descriptions-item>
        <el-descriptions-item label="Conta">{{ dados.person_bank_account.account_number }}</el-descriptions-item>
        <el-descriptions-item label="Tipo de conta" >
          <span v-if="dados.person_bank_account.type === 'payment'">Conta de pagamentos de limite</span>
          <span v-if="dados.person_bank_account.type === 'savings'">Conta Poupança</span>
          <span v-if="dados.person_bank_account.type === 'checking'">Conta corrente</span>
        </el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="!dados.person_addresses" title="Endereço não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions v-else title="Endereços" :column="4" border direction="vertical">
        <el-descriptions-item label="Tipo de Endereço">{{ (dados.person_addresses.type_address === 'personal') ? 'Pessoal' : 'Empresa'  }}</el-descriptions-item>
        <el-descriptions-item label="CEP">{{dados.person_addresses.postal_code}}</el-descriptions-item>
        <el-descriptions-item label="Complemento">{{dados.person_addresses.complement}}</el-descriptions-item>
        <el-descriptions-item label="Bairro">{{dados.person_addresses.neighborhood}}</el-descriptions-item>
        <el-descriptions-item label="Endereço">{{dados.person_addresses.street}}</el-descriptions-item>
        <el-descriptions-item label="Número">{{dados.person_addresses.number}}</el-descriptions-item>
        <el-descriptions-item label="Cidade">{{dados.person_addresses.cidade}}</el-descriptions-item>
        <el-descriptions-item label="Estado">{{dados.person_addresses.estado}}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="!dados.person_documents" title="Documentos não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions title="Documentos" v-else v-for="doc in dados.person_documents" :key="doc.id" :column="5" border direction="vertical">
        <el-descriptions-item label="Tipo">
          <span v-if="doc.type === 'document_photo'">Documeno com foto</span>
          <span v-if="doc.type === 'term_lgpd'">Termo LGPD</span>
          <span v-if="doc.type === 'invoice_limit'">Documento para aumento de limite</span>
          <span v-if="doc.type === 'income_voucher'">Comprovante de renda</span>
          <span v-if="doc.type === 'business_activity'">Atividade empresarial</span>
          <span v-if="doc.type === 'cnpj_card'">Cartão CNPJ</span>
          <span v-if="doc.type === 'address'">Comprovante de endereço</span>
          <span v-if="doc.type === 'others'">Outros</span>
        </el-descriptions-item>
        <el-descriptions-item label="Documento">
          <el-button @click="openUrl(doc.url)" size="small">Download</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="Descrição">{{ doc.description }}</el-descriptions-item>
        <el-descriptions-item label="Data Salvo">
          {{moment(doc.created_at).format('DD/MM/YY HH:mm')}}
        </el-descriptions-item>
        <el-descriptions-item label="Status">
          <tagStatus :status="doc.status" />
        </el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-descriptions v-if="reproveReasons.length > 0" title="Recusado por" :column="1" border direction="vertical">
        <el-descriptions-item v-for="dados in reproveReasons" :key="dados.code" :label=dados.code>{{dados.text}}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <AnalysisRules :rules="rules" />
    </el-card>
  </div>
</template>

<script>
import {getAnaliseRisco, putAprovarAnalise, putReprovarAnalise, getRetryAnalise, putAtualizarStatus} from "@/app/domains/Records/services";
import {makeErrorFilds} from "@/app/plugins/utils";
import HeaderPage from "@/app/components/HeaderPage";
import TagStatus from "@/app/components/Table/TagStatus";
import AnalysisRules from "@/app/components/RiskAnalysis/AnalysisRules";

export default {
  name: "ViewRiskAnalysis",
  components: {
    HeaderPage,
    TagStatus,
    AnalysisRules,
  },
  data () {
    return {
      loadingPage: false,
      dados: {
        person: {},
        data: {
          contact: {},
          address: {},
          bank_account: [],
          document: [],
        },
      },
      dados_caf: {},
      rules: {},
      reproveReasons: {},
    }
  },
  methods: {
    init() {
      this.listDados()
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    async listDados () {
      this.loadingPage = true
      try {
        let response = await getAnaliseRisco(`/${this.$route.params.id}`)
        this.dados = response.data
        this.dados_caf = response.data_caf
        this.rules = response.rules
        this.reproveReasons = response.reproveReasons
      } catch (e) {
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    reprove () {
      this.$prompt('Por favor, insira abaixo o motivo para que a conta seja recusada', 'Deseja realmente recusar está conta?', {
        confirmButtonText: "Confirmar Recusa",
        cancelButtonText: "Cancelar",
        type: 'warning',
        inputValidator: function(value) {
          if (value == null) {
            return "Você precisa preencher o motivo.";
          }
        },
      }).then(async (result) => {
          this.loadingPage = true
          try {
            let response = await putReprovarAnalise(this.$route.params.id, {'status': 'risk_analysis_reproved', 'reason': result.value})
            await this.$router.push({name: 'records.riskAnalysis.index'})
            this.$message({
              showClose: true,
              message: 'Conta atualizada!',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
      });
    },
    approve () {
      this.$confirm('Deseja realmente aprovar está conta?', 'Atenção', {
        center: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          let response = await putAprovarAnalise(this.$route.params.id, {'status': 'risk_analysis_approved'})
          await this.$router.push({name: 'records.riskAnalysis.index'})
          this.$message({
            showClose: true,
            message: 'Conta atualizada!',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    awaiting () {
      this.$confirm('Deseja realmente mudar o status para Aguardando Documentação?', 'Atenção', {
        center: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          let response = await putAtualizarStatus(this.$route.params.id, {'status': 'risk_analysis_awaiting'})
          await this.$router.push({name: 'records.riskAnalysis.index'})
          this.$message({
            showClose: true,
            message: 'Conta atualizada!',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    reject () {
      this.$confirm('Deseja realmente mudar o status para Analise de Risco Rejeitada?', 'Atenção', {
        center: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          let response = await putAtualizarStatus(this.$route.params.id, {'status': 'risk_analysis_rejected'})
          await this.$router.push({name: 'records.riskAnalysis.index'})
          this.$message({
            showClose: true,
            message: 'Conta atualizada!',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    retry () {
      this.$confirm('Deseja realmente reenviar para analise?', 'Atenção', {
        center: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          let response = await getRetryAnalise(this.$route.params.id)
          await this.$router.push({name: 'records.riskAnalysis.index'})
          this.$message({
            showClose: true,
            message: 'Analise Reenviada!',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>